import { combineStorage } from '@atlassian/jira-common-storage-redux/src/config.tsx';
import type { State } from '../../../state/types';
import issuePanelRatio from './issue-panel-ratio';

export default combineStorage<State>(issuePanelRatio);
